
import data from "@/mixins/data"

import ClientHead from "@/components/main/core/ClientHead";
import PricingSectionEx from "@/components/main/pricingExample/PricingSectionEx";
import RedSection from "@/components/main/core/RedSection"
import GreySection from "@/components/main/core/GreySection"
import BoxPhotoExample from "@/components/main/core/BoxPhotoExample"
import CheckBox from "@/components/main/core/CheckBox"




export default {

  head() {
    const title = 'Sample Background Check Report - Best Cheater Lookup | iFindCheater';
    const description = 'Check our Sample partner Background Check Report. Best Websites to Catch and Look Up Cheaters Online. Uncover secrets and confront your unfaithful partner.';

    return {
      title: title,
      meta: [
      {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'Sample Investigation Report, online infidelity Report, Catch a Cheater, Look Up Cheaters Online, Cheating Online, Catch a Cheating Partner Online, websites for catching cheaters, Best Cheater Lookup Websites'
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: title
        }
      ],
      link: [
        {
          hid: "preload",
          rel: "preload",
          as: "image",
          href: require("@/assets/images/main/sample-report-bcg.webp"),
        },
        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/example/",
        },
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Example online profile search",
            }],
          }
        }
      ]
    };
  },

  name: "example",
  layout: 'clientLayout',
  components: { ClientHead, PricingSectionEx, GreySection, BoxPhotoExample, RedSection, CheckBox,  },
  mixins: [
    data,

  ],
}

